import { useContext } from 'react';
import { StoreContext } from '../../business/Provider';
import useApi from '../api';
import { generateUrlBase } from '../../utils/utils';
import {
	GET_COMPANY_VERIFY_LICENSE,
	GET_COMPANY_VERIFY_LICENSE_ERROR,
	GET_COMPANY_VERIFY_LICENSE_SUCCESS,
	LOADING_OFF,
	LOADING_ON,
} from '../../business/constants';
import { Toast } from '../../components/toast';
import { msalConfig } from '../../Auth/b2cService/b2cServiceConfig';
import { useMsal } from '@azure/msal-react';

const useVerifyLicense = () => {
	const context = useContext(StoreContext);
	const { instance } = useMsal();
	const { dispatchCompanyVerifyLicense, dispatchLoading } = context;
	const onChangeCompany = () => {
		const isPayrollCall = JSON.parse(sessionStorage.getItem('isPayrollCall'));

		// Si es un llamado de nómina, limpia los datos y redirige al login
		if (isPayrollCall) {
			localStorage.clear();
			sessionStorage.clear();
			instance.logout();
			return; // Detenemos la ejecución aquí si redirigimos al login
		}

		// Obtiene la URL del portal desde el almacenamiento local o desde la configuración del usuario si no existe
		const redirect = localStorage.getItem('ctiPortalURI');

		// Elimina todas las comillas dobles de la URL
		const url = redirect ? redirect.replace(/"/g, '') : msalConfig.ctiPortalURI;

		// Abre la URL en la misma pestaña
		window.location.replace(url);
	};

	const { genericApiCall } = useApi();
	const verifyLicense = async () => {
		const baseUrl = generateUrlBase('company/verify-license');
		dispatchCompanyVerifyLicense({ type: GET_COMPANY_VERIFY_LICENSE });
		dispatchLoading({ type: LOADING_ON });

		try {
			const result = await genericApiCall(baseUrl, 'GET', {}, {}, {});
			const payload = result.data;

			if (result.status === 200) {
				dispatchCompanyVerifyLicense({
					type: GET_COMPANY_VERIFY_LICENSE_SUCCESS,
					payload,
				});
				return true;
			}
			if (result.status === 401) {
				Toast(
					'warning',
					'La empresa a la cuál desea entrar no está permitida en los accesos de su licencia'
				);
				dispatchCompanyVerifyLicense({ type: GET_COMPANY_VERIFY_LICENSE_ERROR });

				setTimeout(() => {
					onChangeCompany();
				}, 5000);

				return false;
			}

			dispatchCompanyVerifyLicense({ type: GET_COMPANY_VERIFY_LICENSE_ERROR });

			return false;
		} catch (error) {
			const status = error?.response?.status || error?.status;
			if (status === 401) {
				Toast(
					'warning',
					'La empresa a la cuál desea entrar no está permitida en los accesos de su licencia'
				);
				dispatchCompanyVerifyLicense({ type: GET_COMPANY_VERIFY_LICENSE_ERROR });
				
				setTimeout(() => { onChangeCompany(); }, 5000);
				return false;
			}
			Toast('warning', error.message, '', error);
			dispatchCompanyVerifyLicense({ type: GET_COMPANY_VERIFY_LICENSE_ERROR });

			return false;
		} finally {
			dispatchLoading({ type: LOADING_OFF });
		}
	};
	return { verifyLicense };
};

export default useVerifyLicense;
